import { AnnotationBase, AnnotationPlugin } from '@st/document-viewer-kit'
import { SelectToolState } from '~/st-doc-viewer/annotations'
import { INITIAL_TOOL_STATE, SelectToolOverlay } from './ui'

/**
 * The plugin provides the capability for select text on a document for copying.
 *
 * It works by exposing an invisible overlay that allows the user select text by clicking an dragging.
 * It provides visual feedback (blue selection rectangles) as you would expect when using a PDF viewer.
 *
 * It makes use of the page-specific {@link TextRect} data structures that prepresent the boxes of text
 * on the page. When the user clicks and drags, the plugin essentially calculates which text rectangles intersect the
 * drag rectangle and selects the text within those rectangles.
 */
export function selectToolPlugin(): AnnotationPlugin<AnnotationBase, SelectToolState> {
  return {
    name: 'select',
    initialToolState: INITIAL_TOOL_STATE,
    ToolOverlay: SelectToolOverlay
  }
}
